import { AspectRatio } from "~/components/ui/aspect-ratio";

interface Props {
  imageUrl: string;
  title: string;
  children: React.ReactNode;
}

export function LegitAppCard({ imageUrl, title, children }: Props) {
  return (
    <div
      className={
        "group mx-auto bg-secondary text-sidebar-foreground flex w-full max-w-sm flex-col items-start justify-center gap-0 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] border border-border/50 hover:border-primary/20 overflow-hidden"
      }
    >
      <AspectRatio ratio={16 / 9} className="relative overflow-hidden">
        <img
          src={`https://app.7qz.io/cdn-cgi/image/format=auto,quality=9/${
            imageUrl || "/7qz-link-image.svg"
          }`}
          alt={"league-banner"}
          className={
            "object-cover w-full h-full group-hover:scale-105 transition-transform duration-300"
          }
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </AspectRatio>

      <div className="p-6 w-full">
        <h3 className="text-xl font-bold text-foreground mb-4 text-center group-hover:text-primary transition-colors duration-300">
          {title}
        </h3>

        <section className="w-full flex flex-col gap-0">{children}</section>
      </div>
    </div>
  );
}
